module.exports = XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./node_modules/xhr2/lib/browser.js
// module id = 192
// module chunks = 0